import { render } from "./order-fulfillment-details.vue?vue&type=template&id=4d07d8aa&scoped=true"
import script from "./order-fulfillment-details.vue?vue&type=script&lang=js"
export * from "./order-fulfillment-details.vue?vue&type=script&lang=js"

import "./order-fulfillment-details.vue?vue&type=style&index=0&id=4d07d8aa&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d07d8aa"]])

export default __exports__